import { useEffect, useState } from 'react'
import Rating from '@mui/material/Rating';
import { getForumMessages, getStars, setStars } from '../../../api'
import { useAppState } from '../../../hooks'
import './cypher.scss'
import { Heading } from '../../page';
import { ForumForm, ForumMessages } from '../../forum';
import { TForumMessage, TUser } from '../../../types';

type CypherRatingProps = {
    cypherId: number,
    user: TUser
}

export const CypherRating = ({ cypherId, user }: CypherRatingProps) => {
    const [ratingStars, setRatingStars] = useState(0)
    const [messages, setMessages] = useState<TForumMessage[]>()
    const [ratingStarsLabel, setRatingStarsLabel] = useState(0)
    const { state } = useAppState()

    useEffect(() => {
        if (state?.token) {
            getStars({ cypherId: cypherId, token: state?.token })
                .then(res => {
                    if (res.stars) {
                        setRatingStars(res.stars)
                    }
                })
            reloadMessages()
        }
    }, [])

    useEffect(() => {
        
    }, [])

    const reloadMessages = () => {
        getForumMessages({
            forum: cypherId.toString(),
            token: state?.token
        }).then(res => {
            if (!res.errorMessage) {
                setMessages(res.messages)
            }
        })
    }

    useEffect(() => {
        setRatingStarsLabel(ratingStars)
    }, [ratingStars])

    const onRatingChange = (newValue: number | null) => {
        if (newValue && state?.token) {
            setStars({
                cypherId: cypherId,
                token: state?.token,
                stars: newValue
            }).then(res => {
                if (!res.errorMessage) {
                    setRatingStars(newValue)
                }
            })
        }
    }

    const onRatingHover = (newValue: number | null) => {
        if (newValue && newValue > 0) {
            setRatingStarsLabel(newValue)
        } else {
            setRatingStarsLabel(ratingStars)
        }
    }

    function getRatingLabel(): string {
        switch (ratingStarsLabel) {
            case 1: return 'Tohle už prosím vícekrát ne!'
            case 2: return 'Nic moc.'
            case 3: return 'Taková obyčejná šifa, nezaujme, neurazí.'
            case 4: return 'Takhle byla fajn ;)'
            case 5: return 'Lahůdka!'
            default: return ''
        }
    }

    return (
        <>
            <Heading headline={`Jak se vám šifra líbí?`} weight={3} />
            <div className='rating'>
                <Rating
                    name="simple-controlled"
                    value={ratingStars}
                    onChange={(event, newValue) => {
                        onRatingChange(newValue);
                    }}
                    className='rating__stars'
                    onChangeActive={(event, newValue) => {
                        onRatingHover(newValue);
                    }}
                />
                <div className='rating__label'>
                    {getRatingLabel() }
                </div>
            </div>
            <div className='comments'>
                <ForumForm forum={cypherId.toString()} reloadMessage={reloadMessages} user={user }/>
                <div className='forum_messages'>
                    {
                        <ForumMessages messages={messages} />
                    }
                </div>
            </div>
            
        </>
    )
}